import GLightbox from 'glightbox';

const jsonDataBuilder = (marker) => {
  const markerMediaItems = marker.querySelectorAll('.wp-block-riverdale-interactive-map-block-marker-media');
  const mediaItemsObjects = Array.from(markerMediaItems).map(item => ({
    href: item.getAttribute('data-href'),
    type: item.getAttribute('data-type'),
    title: item.getAttribute('data-title'),
    description: item.getAttribute('data-description'),
  }));
  return mediaItemsObjects;
};

const galleryReformatter = () => {
  const galleryContainer = document.querySelector('.glightbox-container .gcontainer');
  if (galleryContainer) {
    const closeBtn = galleryContainer.querySelector('.gclose');
    const sliderContainer = galleryContainer.querySelector('.gslider');
    sliderContainer.insertAdjacentElement('afterbegin', closeBtn);
  }
};

const slideshowLoader = (e) => {
  if (e.target.closest('a')) {
    e.preventDefault();

    const galleryJSON = jsonDataBuilder(e.target.closest('a').parentElement);

    if (galleryJSON) {
      const newGallery = GLightbox({
        elements: galleryJSON,
        skin: 'interactiveMapStyle',
      });
      newGallery.open();
      galleryReformatter();
    }
  }
};

const interactiveMaps = document.querySelectorAll('.wp-block-riverdale-interactive-map-block-container div');
interactiveMaps.forEach(map => map.addEventListener('click', slideshowLoader));
